var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17042",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17042",
    transform: "translate(2496 5848)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15207",
    "data-name": "\\u9577\\u65B9\\u5F62 15207",
    width: 40,
    height: 40,
    transform: "translate(-2496 -5848)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24849",
    "data-name": "\\u30D1\\u30B9 24849",
    d: "M40.776,19.712H11.7L20.6,9.023a2.455,2.455,0,0,0-3.776-3.138L4.564,20.595a2.917,2.917,0,0,0-.221.368.311.311,0,0,1-.172.319,2.355,2.355,0,0,0,0,1.765.311.311,0,0,0,.172.319,2.918,2.918,0,0,0,.221.368l12.259,14.71A2.455,2.455,0,1,0,20.6,35.3L11.7,24.615H40.776a2.452,2.452,0,1,0,0-4.9Z",
    transform: "translate(-2500 -5849.743)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.711c2275bbe91dd9b394f2df54309868.svg";
export { ForwardRef as ReactComponent };